import { render, staticRenderFns } from "./import-submit.vue?vue&type=template&id=cb89d52e"
import script from "./import-submit.vue?vue&type=script&lang=js"
export * from "./import-submit.vue?vue&type=script&lang=js"
import style0 from "./import-submit.vue?vue&type=style&index=0&id=cb89d52e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports